__turbopack_context__.v({
  "container": "GenericRangeInput-module-scss-module__1vBQmq__container",
  "input": "GenericRangeInput-module-scss-module__1vBQmq__input",
  "inputGroup": "GenericRangeInput-module-scss-module__1vBQmq__inputGroup",
  "inputLabel": "GenericRangeInput-module-scss-module__1vBQmq__inputLabel",
  "label": "GenericRangeInput-module-scss-module__1vBQmq__label",
});
